// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-upload-container {
    padding: 0;
}

.crop-icon-active {
    color: #004BA0;
    margin: 0;
}

.image-crop-header-close-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
}

.image-preview-icon-image {
    width: 24px;
    height: 24px;
    cursor: pointer;
}

.image-crop-upload-container {
    background-color: black;
}

.image-crop-upload-container.image-crop-preview-upload {
    background-color: black;
    height: 100%;
}

.image-crop-header-container {
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
}

.image-crop-header-container a {
    cursor: pointer;
}

.image-crop-header-upload-container {
    padding-right: 20px;
}

.image-crop-header-inner-container {
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding-left: 16px;
}

.image-crop-header-inner-container h2 {
    margin-block-start: 18px;
    font-weight: normal;
    font-size: 18px;
}

.image-crop-header-inner-container a {
    cursor: pointer;
}

.image-crop-scroll-container {
    display: flex;
    height: 54px;
    padding: 0 18px;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    border-radius: 12px 12px 0 0;
    position: absolute;
    bottom: 60px;
    width: calc(100% - 36px);
    background: white;
}

.image-crop-options-container {
    display: flex;
    height: 60px;
    padding: 0 18px;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    box-shadow: 0 -4px 6px 0 rgba(0, 0, 0, 0.12);
    position: absolute;
    bottom: 0;
    width: calc(100% - 36px);
    background: white;
}

.image-crop-scroll-aspect-ratio-container {
    display: flex;
    justify-content: space-around;
    width: 100%;
}

.image-crop-scroll-aspect-ratio-container input[type="radio"]:checked + label {
    color: #004BA0;
    cursor: pointer;
}

.image-crop-scroll-aspect-ratio-container input[type="radio"] + label{
    cursor: pointer;
}

/* Style for the dot when radio button is checked */
.image-crop-scroll-aspect-ratio-container input[type="radio"] + label::after {
    content: "";
    margin-left: calc(50% - 3px);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #004BA0;
    display: none;
}

/* Style for checked state */
.image-crop-scroll-aspect-ratio-container input[type="radio"]:checked + label::after {
    display: block;
    visibility: unset;
}

.image-crop-scroll-aspect-ratio-container input[type="radio"]{
    visibility: hidden;
    height: 0;
    width: 0;
}

.material-slider-indicator-container {
    display: flex;
    position: absolute;
    bottom: 3px;
    justify-content: space-between;
    width: 79%;
    left: 11%;
    color: #004BA0;
    font-size: 10px;
    font-weight: 700;
}

.image-avatar-editor {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: calc(100% - 180px);
}

.crop-icon-active {
    font-size: 12px;
    line-height: 16px;
}

.image-preview-rotate-line-icons:hover {
    cursor: pointer;
}

/* Mobile Specific Styles */
@media screen and (max-width: 600px) {
    .image-crop-header-container {
        background: #004BA0;
        height: 45px;
    }
    .image-attachment-popup-container .image-upload-container {
        height: 100%;
        width: 100%;
        padding: 0;
    }
    .image-avatar-editor {
        margin-top: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/builder/css/image-crop.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,4CAA4C;IAC5C,kBAAkB;IAClB,SAAS;IACT,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,mDAAmD;AACnD;IACI,WAAW;IACX,4BAA4B;IAC5B,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;AACjB;;AAEA,4BAA4B;AAC5B;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,UAAU;IACV,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI;QACI,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;QACX,UAAU;IACd;IACA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".image-upload-container {\n    padding: 0;\n}\n\n.crop-icon-active {\n    color: #004BA0;\n    margin: 0;\n}\n\n.image-crop-header-close-icon {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n}\n\n.image-preview-icon-image {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n}\n\n.image-crop-upload-container {\n    background-color: black;\n}\n\n.image-crop-upload-container.image-crop-preview-upload {\n    background-color: black;\n    height: 100%;\n}\n\n.image-crop-header-container {\n    color: white;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n}\n\n.image-crop-header-container a {\n    cursor: pointer;\n}\n\n.image-crop-header-upload-container {\n    padding-right: 20px;\n}\n\n.image-crop-header-inner-container {\n    color: white;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    padding-left: 16px;\n}\n\n.image-crop-header-inner-container h2 {\n    margin-block-start: 18px;\n    font-weight: normal;\n    font-size: 18px;\n}\n\n.image-crop-header-inner-container a {\n    cursor: pointer;\n}\n\n.image-crop-scroll-container {\n    display: flex;\n    height: 54px;\n    padding: 0 18px;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n    border-radius: 12px 12px 0 0;\n    position: absolute;\n    bottom: 60px;\n    width: calc(100% - 36px);\n    background: white;\n}\n\n.image-crop-options-container {\n    display: flex;\n    height: 60px;\n    padding: 0 18px;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n    box-shadow: 0 -4px 6px 0 rgba(0, 0, 0, 0.12);\n    position: absolute;\n    bottom: 0;\n    width: calc(100% - 36px);\n    background: white;\n}\n\n.image-crop-scroll-aspect-ratio-container {\n    display: flex;\n    justify-content: space-around;\n    width: 100%;\n}\n\n.image-crop-scroll-aspect-ratio-container input[type=\"radio\"]:checked + label {\n    color: #004BA0;\n    cursor: pointer;\n}\n\n.image-crop-scroll-aspect-ratio-container input[type=\"radio\"] + label{\n    cursor: pointer;\n}\n\n/* Style for the dot when radio button is checked */\n.image-crop-scroll-aspect-ratio-container input[type=\"radio\"] + label::after {\n    content: \"\";\n    margin-left: calc(50% - 3px);\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: #004BA0;\n    display: none;\n}\n\n/* Style for checked state */\n.image-crop-scroll-aspect-ratio-container input[type=\"radio\"]:checked + label::after {\n    display: block;\n    visibility: unset;\n}\n\n.image-crop-scroll-aspect-ratio-container input[type=\"radio\"]{\n    visibility: hidden;\n    height: 0;\n    width: 0;\n}\n\n.material-slider-indicator-container {\n    display: flex;\n    position: absolute;\n    bottom: 3px;\n    justify-content: space-between;\n    width: 79%;\n    left: 11%;\n    color: #004BA0;\n    font-size: 10px;\n    font-weight: 700;\n}\n\n.image-avatar-editor {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    height: calc(100% - 180px);\n}\n\n.crop-icon-active {\n    font-size: 12px;\n    line-height: 16px;\n}\n\n.image-preview-rotate-line-icons:hover {\n    cursor: pointer;\n}\n\n/* Mobile Specific Styles */\n@media screen and (max-width: 600px) {\n    .image-crop-header-container {\n        background: #004BA0;\n        height: 45px;\n    }\n    .image-attachment-popup-container .image-upload-container {\n        height: 100%;\n        width: 100%;\n        padding: 0;\n    }\n    .image-avatar-editor {\n        margin-top: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
